import api from "../utils/api";

let url = process.env.VUE_APP_INSTALLMENTS;
export const getInstallments = (data) => api.post(url, data);
